import React, { useEffect, useState } from 'react';
import './App.css';
import './components/GlowEffects.css'; // Import the glow effects CSS
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [showLoginPage, setShowLoginPage] = useState(false);

  // Check if user is already logged in from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = (credentials) => {
    // In a real app, you would validate credentials with a backend
    // For this demo, we'll just simulate a successful login
    console.log('Login with:', credentials);

    // Simulate API call delay
    setTimeout(() => {
      const newUser = {
        email: credentials.email,
        username: credentials.email.split('@')[0],
        // In a real app, NEVER store passwords in state or localStorage
      };

      setUser(newUser);
      setIsAuthenticated(true);

      // Store user in localStorage for persistence
      localStorage.setItem('user', JSON.stringify(newUser));
    }, 1000);
  };

  const handleSignup = (userData) => {
    // In a real app, you would send this data to your backend
    console.log('Signup with:', userData);

    // Simulate API call delay
    setTimeout(() => {
      const newUser = {
        email: userData.email,
        username: userData.username,
        // In a real app, NEVER store passwords in state or localStorage
      };

      setUser(newUser);
      setIsAuthenticated(true);

      // Store user in localStorage for persistence
      localStorage.setItem('user', JSON.stringify(newUser));
    }, 1000);
  };

  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
  };

  useEffect(() => {
    // Load particles.js script
    const particlesScript = document.createElement('script');
    particlesScript.src = 'https://cdn.jsdelivr.net/npm/particles.js@2.0.0/particles.min.js';
    particlesScript.async = true;
    document.body.appendChild(particlesScript);

    // Load Web3 script
    const web3Script = document.createElement('script');
    web3Script.src = 'https://cdn.jsdelivr.net/npm/web3@latest/dist/web3.min.js';
    web3Script.async = true;
    document.body.appendChild(web3Script);

    // Initialize particles.js after script is loaded
    particlesScript.onload = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js", {
          particles: {
            number: {
              value: 80,
              density: {
                enable: true,
                value_area: 800
              }
            },
            color: {
              value: "#00ffff"
            },
            shape: {
              type: "circle",
              stroke: {
                width: 0,
                color: "#000000"
              },
              polygon: {
                nb_sides: 5
              }
            },
            opacity: {
              value: 0.5,
              random: false,
              anim: {
                enable: false
              }
            },
            size: {
              value: 3,
              random: true,
              anim: {
                enable: false
              }
            },
            line_linked: {
              enable: true,
              distance: 150,
              color: "#00ffff",
              opacity: 0.4,
              width: 1
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false
            }
          },
          interactivity: {
            detect_on: "canvas",
            events: {
              onhover: {
                enable: true,
                mode: "repulse"
              },
              onclick: {
                enable: true,
                mode: "push"
              },
              resize: true
            },
            modes: {
              grab: {
                distance: 400,
                line_linked: {
                  opacity: 1
                }
              },
              bubble: {
                distance: 400,
                size: 40,
                duration: 2,
                opacity: 8,
                speed: 3
              },
              repulse: {
                distance: 200,
                duration: 0.4
              },
              push: {
                particles_nb: 4
              },
              remove: {
                particles_nb: 2
              }
            }
          },
          retina_detect: true
        });
      }
    };

    // Clean up scripts when component unmounts
    return () => {
      // Only remove scripts if they're still in the DOM
      if (particlesScript.parentNode) {
        document.body.removeChild(particlesScript);
      }
      if (web3Script.parentNode) {
        document.body.removeChild(web3Script);
      }
    };
  }, []);

  // Function to connect wallet - commented out as it's not currently used
  // but kept for future reference
  /*
  const connectWallet = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        alert('Connected account: ' + accounts[0]);
      } catch (error) {
        alert('Connection error: ' + error.message);
      }
    } else {
      alert('Please install MetaMask!');
    }
  };
  */

  // If user is authenticated, show the dashboard
  if (isAuthenticated && user) {
    return (
      <ErrorBoundary>
        <Dashboard user={user} onLogout={handleLogout} />
      </ErrorBoundary>
    );
  }

  // If showing login page
  if (showLoginPage) {
    return (
      <ErrorBoundary>
        <LoginPage
          onLogin={handleLogin}
          onSignup={handleSignup}
          onBack={() => setShowLoginPage(false)}
        />
      </ErrorBoundary>
    );
  }

  // Otherwise, show the landing page
  return (
    <ErrorBoundary>
      <LandingPage onLoginClick={() => setShowLoginPage(true)} />
    </ErrorBoundary>
  );
}

export default App;
